<template>
  <v-layout column class="sidebar mx-0" v-if="matchedFormForSelectedForm">
    <v-layout column style="overflow-y:auto;">
      <template v-for="field in formHeaders(matchedFormForSelectedForm)">
        <v-layout align-center class="pa-2 text-xs-left">
          <v-flex wrap xs6 class="text-xs-left">
            {{ field.text }}
          </v-flex>
          <v-flex
            xs6
            class="darkgrey--text"
            v-if="
              hasUltraTax &&
                matchedFormForSelectedForm.identifier_key === field.key
            "
          >
            Will be matched using SSN specified above
          </v-flex>
          <v-flex xs6 v-else-if="matchedField(field, selectedDocument)">
            <v-select
              v-if="field.field_type === 'state'"
              class="default-input excel-field"
              hide-details
              solo
              flat
              placeholder="State"
              :items="states"
              v-model="matchedField(field, selectedDocument).corrected_value"
              @change="
                updateField(matchedField(field, selectedDocument), $event)
              "
            />

            <v-select
              v-else-if="field.key === 'taxpayer_or_spouse'"
              class="default-input excel-field"
              hide-details
              solo
              flat
              placeholder="Taxpayer or Spouse"
              :items="taxpayerSpouse"
              item-text="label"
              item-value="key"
              v-model="matchedField(field, selectedDocument).corrected_value"
              @change="
                updateField(matchedField(field, selectedDocument), $event)
              "
            />

            <v-select
              v-else-if="field.key === 'taxpayer_spouse_or_joint'"
              class="default-input excel-field"
              hide-details
              solo
              flat
              placeholder="Taxpayer, Spouse, or Joint"
              :items="taxpayerSpouseJoint"
              item-text="label"
              item-value="key"
              v-model="matchedField(field, selectedDocument).corrected_value"
              @change="
                updateField(matchedField(field, selectedDocument), $event)
              "
            />

            <v-select
              v-else-if="field.field_type === 'shortened_state'"
              class="default-input excel-field py-0"
              solo
              flat
              hide-details
              placeholder="State"
              :items="stateKeys"
              v-model="matchedField(field, selectedDocument).corrected_value"
              @change="
                updateField(matchedField(field, selectedDocument), $event)
              "
            />
            <v-checkbox
              v-else-if="field.field_type === 'boolean'"
              solo
              hide-details
              class="ma-0"
              v-model="matchedField(field, selectedDocument).corrected_value"
              true-value="selected"
              false-value="not_selected"
              @change="
                updateField(matchedField(field, selectedDocument), $event)
              "
            />
            <v-layout v-else class="text-xs-center" align-center>
              <span v-if="field.field_type === 'amount'">$ </span
              ><span
                v-if="
                  field.field_type === 'amount' &&
                    matchedField(field, selectedDocument).corrected_value &&
                    matchedField(
                      field,
                      selectedDocument,
                    ).corrected_value.substring(0, 1) === '.'
                "
                >0</span
              >
              <v-text-field
                v-if="field.field_type === 'amount'"
                class="excel-field default-input"
                solo
                hide-details
                v-mask="currencyMask"
                placeholder="Blank"
                v-model="matchedField(field, selectedDocument).corrected_value"
                @change="
                  updateField(matchedField(field, selectedDocument), $event)
                "
              />
              <v-text-field
                v-else
                class="excel-field default-input"
                solo
                hide-details
                placeholder="Blank"
                v-model="matchedField(field, selectedDocument).corrected_value"
                @change="
                  updateField(matchedField(field, selectedDocument), $event)
                "
              />
              <span
                class="grey--text text--darken-1 ml-1"
                v-if="field.field_type === 'percentage'"
                >%</span
              >
            </v-layout>
          </v-flex>
          <v-flex xs6 v-else class="darkgrey--text">
            Not Found
          </v-flex>
        </v-layout>
        <v-divider />
      </template>
    </v-layout>
  </v-layout>
</template>

<script>
import { stateKeys } from '@/constants/variables';
import { isEmpty } from 'lodash';
import UtilsMixins from '../../mixins/UtilsMixins';
import DataEntryMixin from '../../mixins/DataEntryMixin';
import FirmPreferenceMixins from '../../mixins/FirmPreferenceMixins';
import { mapGetters } from 'vuex';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import moment from 'moment';
import API from '@/api';

export default {
  mixins: [UtilsMixins, DataEntryMixin, FirmPreferenceMixins],
  props: {
    documents: {
      type: Array,
    },

    selectedDocument: {
      type: Object,
    },

    matchedFormForSelectedForm: {
      type: Object,
    },

    showAll: {
      type: Boolean,
    },
  },

  data() {
    return {
      stateKeys,

      valid: false,

      rules: {
        required: [value => !!value || 'Required.'],
      },
      currencyMask: createNumberMask({
        prefix: '',
        allowDecimal: true,
        includeThousandsSeparator: true,
        allowNegative: true,
      }),
      taxpayerSpouse: [
        {
          label: 'Taxpayer',
          key: 'taxpayer',
        },
        {
          label: 'Spouse',
          key: 'spouse',
        },
      ],
      taxpayerSpouseJoint: [
        {
          label: 'Taxpayer',
          key: 'taxpayer',
        },
        {
          label: 'Spouse',
          key: 'spouse',
        },
        {
          label: 'Joint',
          key: 'joint',
        },
      ],
    };
  },

  computed: {
    ...mapGetters(['currentFirm']),
    ...mapGetters({
      currentUser: 'user',
    }),
  },
  methods: {
    isEmpty,
    moment,
    formHeaders(form) {
      return form.mapping
        .filter(mapping =>
          this.showAll
            ? true
            : [
                'street',
                'city',
                'fname',
                'lname',
                'ssn',
                'employee_',
                'recipient_',
                'zip',
                'city',
                'state',
                'recipient_name',
                'phone',
              ].every(a => !mapping.key.includes(a)),
        )
        .map(mapping => {
          return {
            text: mapping.label,
            key: mapping.key,
            field_type: mapping.field_type,
            align: 'left',
            sortable: true,
            value: mapping.key,
            width: '12%',
          };
        });
    },
    findTotals(field) {
      let array = this.documents
        .map(a => a.extracted_document_fields)
        .flatten()
        .filter(a => a.corrected_value && a.key === field.value)
        .map(a =>
          Number(parseFloat(a.corrected_value.replace(',', '')).toFixed(2)),
        );
      return isEmpty(array) ? '-' : array.reduce((a, b) => a + b, 0).toFixed(2);
    },
    getSubField(field, key) {
      return field.subfields.find(subfield => subfield.key.endsWith(key));
    },
    matchedField(field, form) {
      return form.extracted_document_fields.find(a => a.key === field.value);
    },
    async updateField(field, newValue) {
      try {
        await API.extractedDocument.updateExtractedDocumentField({
          companyId: this.selectedDocument.company_id,
          extractedDocumentId: this.selectedDocument.id,
          extractedDocumentFieldId: field.id,
          correctedValue: newValue,
        });
      } catch (error) {
        console.error(error);
      }
    },
  },
  watch: {
    matchedFormForSelectedForm: {
      handler() {
        console.log(
          `form changed:`,
          this.selectedDocument,
          this.matchedFormForSelectedForm,
        );
      },
      immediate: true,
    },
  },
};
</script>

<style lang="postcss" scoped>
.sidebar {
  overflow: auto;
  margin-left: 30px;
  flex: 0;
  min-width: 400px;
}

.selected-row {
  background-color: #d3dffa;
}

.non-selected-row {
  background-color: white;
}
.excel-table thead tr th:nth-child(n) {
  background-color: white;
}
.excel-table tfoot tr td:nth-child(1) {
  background-color: white;
}
</style>
